import AxiosAuth2 from "../../services/axios-service-auth";

const sendPush = (id,data) => {
  return AxiosAuth2.post("/api/patient/sendPush/"+id, data, undefined);
};

export default {
    sendPush,
};
